import React, { useContext } from 'react'
import Context from '../context'
import SVG from './SVG'

const BackToTop: React.FC = () => {
  const { state } = useContext(Context)

  return (
    <div data-testid="back-to-top" className={`back-to-top${state.showBackToTop ? '-show' : ''}`}>
      <div className="back-to-top_footer-barrier">
        <button
          className="button back-to-top__button"
          onClick={() => {
            state.ionContent.current.scrollToTop(250)
            const focusTop = document.querySelector('.filters__button') as HTMLElement
            focusTop.focus()
          }
            }>
          <SVG name="back--white" label="back--white" size="base" />
          <span>TOP</span>
        </button>
      </div>
    </div>
  )
}

export default BackToTop
